import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context";
import {
  getIsModalOpen,
  useModalService,
  useModalState
} from "./../../../ricos-modals/modal-service-provider";
import { DropdownButton } from "./../../../toolbars-ui";
import { SingleLineStyle } from "../../icons";
import LineStylePanel from "../modals/LineStylePanel";
import { dividerStyleData } from "./dividerButtonsData";
const DividerStyleButton = ({ toolbarItem, dataHook, id }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useModalService();
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedStyle = () => toolbarItem?.attributes.nodeStyle || "SINGLE";
  const SelectedStyleIcon = dividerStyleData.find(({ commandKey }) => commandKey === getSelectedStyle())?.icon || SingleLineStyle;
  const closeModal = () => modalService.closeModal(id);
  const onStyleClick = (lineStyle) => {
    toolbarItem.commands?.click({ value: lineStyle });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService.openModal({
      Component: LineStylePanel,
      id,
      componentProps: {
        getSelectedStyle,
        onClick: onStyleClick,
        isMobile
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      setRef: setReferenceElement,
      Icon: () => /* @__PURE__ */ React.createElement(SelectedStyleIcon, { width: 36 }),
      tooltip: t("DividerPlugin_SelectType_Tooltip")
    }
  );
};
export {
  DividerStyleButton
};
//# sourceMappingURL=DividerStyleButton.js.map
